import React from 'react';
import { Box, Link, Stack, Typography } from '@mui/material';
import { SAFEVAULT_BRAND } from '../theme/safevaultBrand';

const contactLinkSx = {
    color: SAFEVAULT_BRAND.textNavy,
    fontFamily: 'Inter, sans-serif',
    fontSize: 'clamp(0.875rem, 1.17vw, 1rem)',
    textDecoration: 'none',
    '&:hover': { opacity: 0.75 },
};

const BlogArticleContact = () => (
    <Box
        className="blog-article-contact"
        sx={{
            mt: 4,
            pt: 3,
            borderTop: `1px solid ${SAFEVAULT_BRAND.footerBorder}`,
            maxWidth: '980px',
            mx: 'auto',
        }}
    >
        <Typography
            sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 600,
                color: SAFEVAULT_BRAND.textNavy,
                fontSize: 'clamp(1rem, 1.25vw, 1.125rem)',
                mb: 2,
            }}
        >
            Thanks for reading! Let&apos;s connect and continue the conversation.
        </Typography>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 2, sm: 4 }}>
            <Box>
                <Typography
                    sx={{
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 700,
                        color: SAFEVAULT_BRAND.textNavy,
                        fontSize: '0.875rem',
                        mb: 0.5,
                    }}
                >
                    Email
                </Typography>
                <Link href={`mailto:${SAFEVAULT_BRAND.contactEmail}`} sx={contactLinkSx}>
                    {SAFEVAULT_BRAND.contactEmail}
                </Link>
            </Box>
            <Box>
                <Typography
                    sx={{
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 700,
                        color: SAFEVAULT_BRAND.textNavy,
                        fontSize: '0.875rem',
                        mb: 0.5,
                    }}
                >
                    Phone
                </Typography>
                <Link href={`tel:${SAFEVAULT_BRAND.contactPhone}`} sx={contactLinkSx}>
                    {SAFEVAULT_BRAND.contactPhone}
                </Link>
            </Box>
        </Stack>
    </Box>
);

export default BlogArticleContact;
